var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadlineGenerator1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05887 0 0 8.05888 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#E1EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4556 22.4813V21.2358H10.0522V22.4813H18.4556ZM25.6865 19.0563V17.8109H10.0522V19.0563H25.6865ZM25.6865 15.6315V14.3861H10.0522V15.6315H25.6865ZM25.6865 12.2066V10.9612H10.0522V12.2066H25.6865Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1508 21.1131L24.7485 20.24L24.36 21.1131L23.4869 21.5017L24.36 21.904L24.7485 22.768L25.1508 21.904L26.0148 21.5017L25.1508 21.1131Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8916 21.1716L21.1054 22.9088L19.3636 23.6996L21.1054 24.4905L21.8916 26.2275L22.6825 24.4905L24.4242 23.6996L22.6825 22.9088L21.8916 21.1716Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlineGenerator1);
export default __webpack_public_path__ + "static/media/HeadlineGenerator1.ece5dbde2303c72e90d51303e5c6bb5a.svg";
export { ForwardRef as ReactComponent };